/* eslint max-len: 0 */
import React, { SVGProps } from 'react';

const WifiSecurity = (props: SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="icon icon--wifiSecurity"
      {...props}
    >
      <path
        d="M8.33302 5.66666C9.49969 5.66666 10.5997 6.06666 11.4664 6.69999L12.2664 5.63332C11.1664 4.79999 9.79969 4.33332 8.33302 4.33332H7.66636C6.19969 4.33332 4.86636 4.79999 3.76636 5.59999L4.56636 6.66666C5.43302 6.03332 6.49969 5.66666 7.66636 5.66666H8.33302Z"
        fill="white"
      />
      <path
        d="M10.6664 7.76666C9.99971 7.29999 9.19971 6.99999 8.33304 6.99999H7.66637C6.79971 6.99999 5.99971 7.26666 5.36637 7.73332L6.16637 8.79999C6.59971 8.49999 7.13304 8.33332 7.69971 8.33332H8.36637C8.93304 8.33332 9.46637 8.49999 9.89971 8.83332L10.6664 7.76666Z"
        fill="white"
      />
      <path
        d="M7.96631 9.66666C7.23298 9.66666 6.63298 10.2667 6.63298 11C6.63298 11.7333 7.23298 12.3333 7.96631 12.3333C8.69964 12.3333 9.29964 11.7333 9.29964 11C9.29964 10.2667 8.69964 9.66666 7.96631 9.66666Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.2997 2.46666L14.6663 2.33332V7.89999C14.6663 10.2333 13.433 12.4 11.433 13.6L7.99967 15.6667L4.56634 13.6C2.56634 12.4 1.33301 10.2333 1.33301 7.89999V2.33332L2.66634 2.46666C3.96634 2.59999 5.26634 2.29999 6.36634 1.63332L7.99967 0.666656L9.59967 1.63332C10.733 2.29999 11.9997 2.59999 13.2997 2.46666ZM8.93301 2.76666C10.2663 3.56666 11.7997 3.93332 13.333 3.79999V7.93332C13.333 9.79999 12.333 11.5333 10.733 12.5L7.99967 14.1333L5.26634 12.5C3.63301 11.5333 2.66634 9.79999 2.66634 7.93332V3.83332C4.19967 3.93332 5.73301 3.59999 7.06634 2.79999L7.99967 2.23332L8.93301 2.76666Z"
        fill="white"
      />
    </svg>
  );
};

WifiSecurity.displayName = 'wifiSecurity';

export default WifiSecurity;
